module.exports = __webpack_public_path__ + "img/usb-manage.3eec6da7.png";